/*# sourceMappingURL=/ba/public/supplier-landing-page.component.css.map */
